import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {useQueryClient} from '@tanstack/react-query'
import {Dialog} from 'primereact/dialog'
import {forwardRef, useImperativeHandle, useMemo} from 'react'
import {useParams} from 'react-router-dom'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../query-manager/QueryKeyTypes'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
import {useAuth} from '../authentication/AuthProvider'
import CustomForm from '../form-utils/CustomForm'
import {formLayout, getComposedDataList} from '../form/Constant'
import {noteList} from './NoteConstant'
import {useNoteCRUD} from './query-keys/NoteKeysManager'

const NoteForm = forwardRef((props, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    //#region Context
    const {user} = useAuth()
    //#endregion

    //#region Translate
    const {translateDatatable} = TranslateUtils()
    //#endregion

    //#region ID
    const {id: idString} = useParams()
    const id = useMemo(() => {
        return !!idString ? parseInt(idString) : null
    }, [idString])
    //#endregion

    //#region State
    const visible = useSignal(false)
    const data = useSignal({})
    //#endregion

    //#region Query
    const queryClient = useQueryClient()

    const {mutateAsync: createOrUpdateNote} = useNoteCRUD(
        !!data.value?.id ? QueryCRUDTypes.update : QueryCRUDTypes.create,
        user?.id,
    )
    //#endregion

    //#region Handle Function
    const handleShowForm = value => {
        blockOverflownScroll()
        data.value = value && Object.keys(value)?.length > 0 ? {...value} : {}
        visible.value = true
    }

    const handleHideForm = () => {
        unblockOverflownScroll()
        data.value = {}
        visible.value = false
    }

    const handleOnSubmit = async value => {
        let toPostData = {
            ...value,
            userId: id,
            id: data.value?.id ? data.value.id : null,
        }

        const noteData = await createOrUpdateNote(toPostData)

        if (noteData?.id) {
            const {noteKeys} = QueryKeyManager(QueryKeyTypes.note, user?.id)

            //TODO: Temporary Refetch Table
            queryClient.invalidateQueries({
                queryKey: noteKeys.pattern(),
            })

            // try {
            //     reloadDataTable(QueryTableKey + id, noteData)
            // } catch (err) {
            //     console.log('Fail to reload table')
            // }

            handleHideForm()
        }
    }
    //#endregion

    //#region Memo
    const dataList = useMemo(() => {
        return getComposedDataList(noteList, data.value)
    }, [data.value])

    return (
        <Dialog
            className=""
            visible={visible.value}
            onHide={handleHideForm}
            header={translateDatatable('NOTE FORM')}
            blockScroll>
            <CustomForm
                dataList={dataList}
                layout={formLayout.flex}
                onSubmit={handleOnSubmit}
            />
        </Dialog>
    )
})

export default NoteForm
